// Utility to sync asset <-> data type links
import { getDataTypeById, updateDataType } from '@/services/dataRetentionService';

/**
 * Syncs the asset ID list on each data type entity when an asset adds/removes a data type
 * @param assetId - The asset being updated
 * @param prevDataTypeIds - Array of data type IDs before the change
 * @param newDataTypeIds - Array of data type IDs after the change
 * @returns Promise<void>
 */
export async function syncDataTypeAssets(
  assetId: string,
  prevDataTypeIds: string[],
  newDataTypeIds: string[]
) {
  // Find added and removed data type IDs
  const added = newDataTypeIds.filter(x => !prevDataTypeIds.includes(x));
  const removed = prevDataTypeIds.filter(x => !newDataTypeIds.includes(x));

  // For each added data type, add this asset to its asset list (if modeled)
  for (const dataTypeId of added) {
    console.log('[syncDataTypeAssets] Adding asset to data type:', { assetId, dataTypeId });
    const dataType = await getDataTypeById(Number(dataTypeId));
    console.log('[syncDataTypeAssets] Found data type:', dataType);
    if (dataType) {
      let assets = Array.isArray(dataType.assets) ? [...dataType.assets] : [];
      if (!assets.includes(assetId)) {
        assets.push(assetId);
        await updateDataType(Number(dataTypeId), { assets: assets, suppliers: assets });
      }
    }
  }
  // For each removed data type, remove this asset from its asset list
  for (const dataTypeId of removed) {
    console.log('[syncDataTypeAssets] Removing asset from data type:', { assetId, dataTypeId });
    const dataType = await getDataTypeById(Number(dataTypeId));
    console.log('[syncDataTypeAssets] Found data type:', dataType);
    if (dataType) {
      let assets = Array.isArray(dataType.assets) ? [...dataType.assets] : [];
      console.log('[syncDataTypeAssets][REMOVE] Initial assets array:', assets, 'assetId:', assetId, 'typeof assetId:', typeof assetId);
      const beforeLength = assets.length;
      const filteredAssets = assets.filter(id => {
        // Always compare as strings for robust matching
        const idStr = String(id);
        const assetIdStr = String(assetId);
        const keep = idStr !== assetIdStr;
        console.log('[syncDataTypeAssets][REMOVE] Comparing (as strings):', {id, idStr, assetId, assetIdStr, typeofId: typeof id, typeofAssetId: typeof assetId, keep});
        return keep;
      });
      console.log('[syncDataTypeAssets][REMOVE] Filtered assets:', filteredAssets, 'Removed:', beforeLength - filteredAssets.length);
      if (assets.length !== filteredAssets.length) {
        const updateResult = await updateDataType(Number(dataTypeId), { assets: filteredAssets, suppliers: filteredAssets });
        console.log('[syncDataTypeAssets][REMOVE] updateDataType result:', updateResult);
      } else {
        console.log('[syncDataTypeAssets][REMOVE] No change to assets array, skipping update.');
      }
    }
  }
}
